import StudentAssignmentsContainer from './AssignmentsContainer';
export default StudentAssignmentsContainer;
